import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, inject, NgZone, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbAccordionModule, NgbDropdown, NgbDropdownModule, NgbModal, NgbOffcanvas, NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { confirmationMessages } from '../../../utils/popup-messages';
import { fileDirectories } from '../../../utils/view-settings';
import { NotificationPopupComponent } from '../../popups/notification-popup/notification-popup.component';
import { SearchPopupComponent } from '../../popups/search-popup/search-popup.component';
import { ViewStorePopupComponent } from '../../popups/view-store-popup/view-store-popup.component';
import { AuthService } from '../../services/auth.service';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { BrowserStorageService } from '../../services/common/browser-storage.service';
import { ConfirmationPopupComponent } from '../../services/common/popups/confirmation-popup/confirmation-popup.component';
import { ApiCallsService } from '../../services/network/api-calls.service';
import { UserService } from '../../services/user.service';

import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { api } from '../../../utils/endpoints';
import { ICONS } from '../../../utils/svg-icons';
import { LocationService } from '../../services/location.service';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, RouterLink, NgbDropdownModule, NgbAccordionModule, SafeHtmlPipe, NgbPopoverModule, NgSelectModule, FormsModule],
})
export class HeaderComponent {
  activeIndex: number = 0;
  menuOpen: boolean = false;
  previousUrl: string | undefined;
  currentUrl: string | undefined;
  showTooltip: boolean = false;
  public isCollapsed = true;
  public userLoggedIn = false;
  storeUrl = environment.storeUrl;
  adminDetail: any;
  userInfo: any;
  fileDirectoriesPath: string = fileDirectories.profile;
  currentStep: number = 1;
  totalSteps: number = 5;
  isSearchPopupVisible: boolean = true;
  isNotificationVisible: boolean = true;
  cartStoreURL: string = (environment as any).cartStoreURL;
  private offcanvasService = inject(NgbOffcanvas);
  unreadNotificationsCount: any = 0;
  showMenu = false;
  shopifyCart: any;
  screenWidth: number = 0;
  resizeObserver: ResizeObserver | null = null;
  sportList: any = [];
  sportsRoute = '/sports';
  ICONS = ICONS;
  selectedLocation: any; // or use a specific type
  suggestions: { name: string; placeId: string; lat?: number; lng?: number; main_text: any; secondary_text: any }[] = [];
  private autocompleteService!: google.maps.places.AutocompleteService;
  private geocoder!: google.maps.Geocoder;
  selectedValue: any = [];
  isPopoverOpen = false;
  @ViewChild('popoverRef') popover!: NgbPopover;
  @ViewChild('dropdownRef') dropdown!: NgbDropdown;

  constructor(
    private _commonDataService: CommonDataSharingService,
    private _ngbModal: NgbModal,
    private _auth: AuthService,
    private _router: Router,
    private _storageService: BrowserStorageService,
    private _userService: UserService,
    private _apiService: ApiCallsService,
    private _ref: ChangeDetectorRef,
    private _location: LocationService,
    private zone: NgZone,
  ) {
    if (this._storageService.getBrowser()) {
      this._userService.user.subscribe((user) => {
        if (user) {
          this.userInfo = user;
        }
      });
      this._commonDataService.headerProfile.subscribe((shouldReload: any) => {
        if (shouldReload) {
          this.userInfo = _userService.getUserData();
        }
      });
      this._userService.shopifyCartCount$.subscribe((count: any) => {
        this.shopifyCart = count;
      });
      this._location.fetchLocation();
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
      if (localStorage.getItem('userLocation')) {
        let value: any = localStorage.getItem('userLocation');
        if (value) {
          value = JSON.parse(value);
          this._location.getLocationName(value.lat, value.lng).then((locationName) => {
            this.selectedLocation = locationName;
            if (this.selectedLocation) {
              this.suggestions.push({ ...value, name: this.selectedLocation, main_text: this.selectedLocation, placeId: '-', secondary_text: '' });
              this.selectedValue.push({ ...value, name: this.selectedLocation, main_text: this.selectedLocation, placeId: '-', secondary_text: '' });
            }
          });
        }
        // this._ref.detectChanges();
      }
    }
  }

  logout(): void {
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'small confirmationPopup',
    });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.logout;
    modalRef.result.then((res: any) => {
      if (res) {
        this._auth.signOut();
        this.reload();
        this.userInfo = undefined;
        this.userLoggedIn = false;
      }
    });
  }
  ngOnInit(): void {
    if (this._storageService.getBrowser()) {
      this.previousUrl = this._userService.getCurrentUrl();
      if (this.previousUrl === '/profile/step-three') {
        this.showTooltip = true;
      }

      this.adminDetail = this._storageService.getItem('userDetail');
      this._navigateToDashboard(this.adminDetail);
      this._userService.user.subscribe((user: any) => {
        if (user) {
          this.userInfo = user ?? null;
        }
      });
      this._getsportList();
    }
  }
  ngAfterViewInit() {
    if (this._storageService.getBrowser()) {
      this.screenWidth = window.innerWidth;

      this.resizeObserver = new ResizeObserver(() => {
        this.screenWidth = window.innerWidth;
        this.sportsRoute = this.userInfo?.id && this.screenWidth > 990 ? '/sports' : '';
      });
      // this.resizeObserver.observe(document.body);
    }
    this._ref.detectChanges();
  }
  ngOnDestroy() {
    if (this._storageService.getBrowser()) {
      this.resizeObserver?.disconnect();
      document.body.style.overflow = '';
    }
  }
  private _getsportList(): void {
    this._apiService.get(api._elementListing, this._getRequest()).subscribe({
      next: (res: any) => {
        if (res) {
          this.sportList = res?.data.rows
            .filter((row: any) => !/mixed/i.test(row?.name)) // 🚫 Filter out rows with "Mixed" in the name
            // .slice(0, 5)
            .map((row: any) => {
              const sortedCategories = [...(row?.categories || [])].sort((a: any, b: any) =>
                (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }),
              );
              // const allSports = row?.categories?.flatMap((category: any) => category?.sports || []);
              const allSports = sortedCategories
                .flatMap((category: any) => category?.sports || [])
                .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
              // .slice(0, 6) || [];

              return {
                ...row,
                // categories: sortedCategories, // ✅ sorted categories
                allSports,
                totalAllSportsCount: row?.categories.length,
              };
            });
        }
      },
      error: (error: any) => console.log(error),
    });
  }
  private _getRequest(): HttpParams {
    // let currentPage = Number.isNaN(this.pagination.skip) || this.pagination.skip == 0 ? 1 : this.pagination.skip;
    // this.pagination.skip = currentPage;
    let params: any = {};
    params['scope'] = 'withSports';
    // params['page'] = 1;
    params['limit'] = 10;
    return params;
  }
  private _navigateToDashboard(accountToken: string): void {
    if (accountToken) {
      this.userLoggedIn = true;
      this.notificationTriggerOn15sec();
    } else {
      const userdata = this._storageService.getItem('userDetailForComplete');
      if (userdata) {
        let userInfo = JSON.parse(userdata);
        if (userInfo.signUpStep == 1 || userInfo.signUpStep == '1') {
          this._router.navigate(['/profile/step-two']);
        } else if (userInfo.signUpStep == 2 || userInfo.signUpStep == '2') {
          this._router.navigate(['/profile/step-three']);
        }
      }
    }
  }
  viewMenu(path: any) {
    this.adminDetail = this._storageService.getItem('userDetail');
    if (this.adminDetail) {
      this._router.navigate([path]);
    } else {
      this._router.navigate(['/auth/login']);
    }
  }

  onNextClick(): void {
    if (this.currentStep < 5) {
      this.currentStep++;
    } else {
      this.currentStep = 1;
      this.onSkipAll();
    }
  }

  onItemClick(index: number): void {
    this.activeIndex = index;
  }
  setActiveIndex(index: number): void {
    this.activeIndex = index;
  }

  onExploreClick(event: any, entity: any) {
    if (this._storageService.getBrowser()) {
      document.body.style.overflow = ''; // enable scroll
    }
    this.notificationTriggerOn15sec();
    event.preventDefault();
    let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'filterPopup',
      centered: true,
    });
    modalRef.componentInstance.entity = entity;
  }
  onSkipAll(): void {
    this.showTooltip = false;
    this._userService.setUrls(null, null);
    this.reload();
  }
  reload() {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  storeRedirect() {
    // this._apiService.post(api._poductsUrl, { redirectUrl: this.cartStoreURL }).subscribe({
    //   next: (res: any) => {
    //     if (this._storageService.getBrowser()) {
    //       window.open(res.data.loginUrl, '_blank');
    //     }
    //   },
    // });
    if (this._storageService.getBrowser()) {
      window.open(this.cartStoreURL, '_blank');
    }
  }
  searchOpen() {
    const offcanvasRef = this.offcanvasService.open(SearchPopupComponent, {
      // position: 'end',
      panelClass: 'offcanvas offcanvas-top search_height',
      // backdrop: true,
    });
  }
  NotificationsOpen() {
    const offcanvasRef = this.offcanvasService.open(NotificationPopupComponent, {
      position: 'end',
      panelClass: 'custom-offcanvas-header',
      // backdrop: true,
    });
  }
  notificationTriggerOn15sec() {
    const token = this._storageService.getCookie('authToken');
    if (this._storageService.getCookie('authToken')) {
      setTimeout(() => {
        if (
          this.userLoggedIn == true &&
          this.userInfo != null &&
          this._storageService.getBrowser() &&
          document.visibilityState === 'visible' &&
          token != undefined &&
          token != null
        ) {
          this._commonDataService._getToggleNotification(2, 0).subscribe({
            next: (res: any) => {
              if (res) {
                this.unreadNotificationsCount = res.data.unreadNotificationsCount || 0;
                this.notificationTriggerOn15sec();
              }
            },
            error: (err: any) => {
              console.log(err);
            },
          });
        }
      }, 15000);
    }
  }
  toggleMenuOpen(open: boolean) {
    if (this._storageService.getBrowser()) {
      this.showMenu = open;
      if (open) {
        document.body.style.overflow = 'hidden'; // disable scroll
        if (this.popover?.isOpen()) {
          this.popover.close();
        }
        // Close dropdown if open
        if (this.dropdown?.isOpen()) {
          this.dropdown.close();
        }
      } else {
        document.body.style.overflow = ''; // enable scroll
      }
    }
  }
  onSearchInputChange(event: any): void {
    if (event.term < 2) {
      this.suggestions = [];
      return;
    }
    this.suggestions = [];
    if (this.selectedValue && this.selectedValue?.length > 0) {
      this.suggestions.push(this.selectedValue);
    }
    this.autocompleteService.getPlacePredictions(
      {
        input: event.term,
        componentRestrictions: { country: 'us' },
      },
      (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          this.suggestions = predictions.map((p) => ({
            name: p.description,
            placeId: p.place_id,
            main_text: p.structured_formatting.main_text,
            secondary_text: p.structured_formatting.secondary_text,
          }));
          this._ref.detectChanges();
        } else {
          this.suggestions = [];
          this._ref.detectChanges();
        }
        this._ref.detectChanges();
      },
    );
  }
  select(event: any) {
    if (event.lat == undefined || event.lat == '' || event.lat == null) {
      this.getLatLngFromPlaceId(event);
    }
  }
  getLatLngFromPlaceId(place: { name: string; placeId: string; lat: any; lng: any; main_text: any; secondary_text: any }) {
    this.geocoder.geocode({ placeId: place.placeId }, (results: any, status: any) => {
      if (status === 'OK' && results[0]?.geometry?.location) {
        const location = results[0].geometry.location;
        this.zone.run(() => {
          place.lat = location.lat();
          place.lng = location.lng();
          this._location.setLocation(place);
        });
      }
    });
  }

  getCurrentLocation() {
    this._location.getCurrentLocation().then((coords) => {
      this._location.getLocationName(coords.lat, coords.lng).then((locationName) => {
        this.selectedLocation = locationName;

        this._location.setLocation({ ...coords });
        if (this.selectedLocation) {
          this.suggestions = [];
          let value = {
            lat: coords.lat,
            lng: coords.lng,
            name: this.selectedLocation,
            placeId: '-',
            main_text: this.selectedLocation,
            secondary_text: '',
          };
          this.suggestions.push(value);
          this.selectedValue.push(value);
        }
      });
    });
  }
}
